import i18next from 'i18next';
import React, { BaseSyntheticEvent } from 'react';
import { Input } from 'reactstrap';
import {
  THeader,
  TTableBody,
  TTableRow
} from '../../../shared_components/vrr_table/types';
import { TBrandRow } from '../../connected_brand/types';
import { TAccountsAPI } from '../types';

export const prepareHeader = (
  onChangeAction?: (isChecked: boolean) => void
): THeader['element'][] => {
  return [
    {
      id: 'vrr_id',
      component: (
        <p>
          {i18next
            .t('connected_account.accounts_table.header.vrr_id')
            .toUpperCase()}
        </p>
      )
    },
    {
      id: 'name',
      component: (
        <p>
          {i18next
            .t('connected_account.accounts_table.header.name')
            .toUpperCase()}
        </p>
      )
    },
    {
      id: 'role',
      component: (
        <p className="accounts-table-header-status">
          <Input
            id={`accounts-table-all`}
            type="checkbox"
            className="accounts-table-input"
            onClick={(e: BaseSyntheticEvent) => {
              if (onChangeAction) onChangeAction(e.target.checked);
            }}
          />
          {i18next
            .t('connected_account.accounts_table.header.role')
            .toUpperCase()}
        </p>
      )
    }
  ];
};

export const prepareLine = (account: {
  vrr_id: string;
  name: string;
  role: string;
}): TBrandRow[] => {
  const header = prepareHeader();
  return Object.values(account)?.map((cell, index) => ({
    headerId: header[index].id,
    rowId: account.vrr_id.toString(),
    value: cell
  }));
};

const getLine = (
  line: TBrandRow[],
  onChangeAction?: (value: string, isChecked: boolean) => void
): TTableRow['cellElements'] => {
  const newLine = [];
  line.forEach((cell) => {
    if (cell.headerId !== 'role') {
      newLine.push({
        headerId: cell.headerId,
        id: cell.rowId,
        component: (
          <label
            className="accounts-table-value"
            htmlFor={`accounts-table-${line[0].rowId}`}
          >
            <span>{cell.value}</span>
          </label>
        ),
        value: cell.value
      });
    }
  });
  newLine.push({
    headerId: 'checkbox',
    id: line[0].rowId,
    component: (
      <Input
        id={`accounts-table-${line[0].rowId}`}
        type="checkbox"
        checked={line[2].value === 'media_buyer'}
        className="accounts-table-input"
        onClick={(e: BaseSyntheticEvent) => {
          if (onChangeAction) onChangeAction(line[0].value, e.target.checked);
        }}
      />
    ),
    value: ''
  });

  return newLine;
};

export const prepareBody = (
  accounts?: TAccountsAPI[],
  onChangeAction?: (value: string, isChecked: boolean) => void
): TTableBody['rowElements'] => {
  const newBody: TTableBody['rowElements'] = [];
  accounts?.forEach((account) => {
    const line = prepareLine({
      vrr_id: account.vrr_id.toString(),
      name: account.name,
      role: account.role
    });
    newBody.push(getLine(line, onChangeAction));
  });

  return newBody;
};
